import React from 'react';
import { Link } from 'react-router-dom';

const isSolo = process.env.REACT_APP_SOLO_LANDING === 'true';
const homePath = isSolo ? '/' : '/';

export function LegalLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white dark:from-gray-900 dark:to-gray-800">
      <header className="sticky top-0 z-40 border-b border-slate-200/60 bg-white/90 backdrop-blur-lg dark:bg-gray-900/80">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 flex-wrap gap-2">
          <Link to={homePath} className="flex items-center gap-2">
            {isSolo ? (
              <>
                <img src="/brand/White logo on purple.png" alt="SEN-Education" className="h-9 w-9 rounded-lg" />
                <span className="font-bold text-lg text-purple-600 dark:text-purple-400">SEN-Education</span>
              </>
            ) : (
              <>
                <img src="/brand/Logo.png" alt="SEN-Ed" className="h-9 w-9 rounded-lg" />
                <span className="font-bold text-lg text-gray-900 dark:text-white">SEN-Ed</span>
              </>
            )}
          </Link>
          <nav className="flex items-center gap-3 sm:gap-4 text-sm flex-wrap" aria-label="Main">
            {isSolo ? (
              <>
                <Link to="/" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Home</Link>
                <Link to="/about" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">About</Link>
                <Link to="/contact" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Contact</Link>
                <Link to="/privacy" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Privacy</Link>
                <Link to="/terms" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Terms</Link>
                <Link to="/security" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Security</Link>
                <Link to="/cookies" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Cookies</Link>
                <a href="https://sen-ed.co.uk" rel="noopener noreferrer" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Go to our schools site</a>
              </>
            ) : (
              <>
                <Link to="/privacy" className="text-gray-600 hover:text-indigo-600 dark:text-gray-300">Privacy</Link>
                <Link to="/terms" className="text-gray-600 hover:text-indigo-600 dark:text-gray-300">Terms</Link>
                <Link to="/security" className="text-gray-600 hover:text-indigo-600 dark:text-gray-300">Security</Link>
              </>
            )}
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8" role="main">
        <article className="prose prose-slate dark:prose-invert max-w-none">
          {children}
        </article>
      </main>

      <footer className="border-t border-slate-200 dark:border-gray-700 py-8 mt-12 bg-slate-50/50 dark:bg-gray-900/30" role="contentinfo">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-500 dark:text-gray-400">
            <Link to={homePath} className="flex items-center gap-2">
              {isSolo ? (
                <>
                  <img src="/brand/White logo on purple.png" alt="SEN-Education" className="h-8 w-8 rounded-lg" />
                  <span className="font-semibold text-purple-600 dark:text-purple-400">SEN-Education</span>
                </>
              ) : (
                <>
                  <img src="/brand/Logo.png" alt="SEN-Ed" className="h-8 w-8 rounded-lg" />
                  <span className="font-semibold text-gray-900 dark:text-white">SEN-Ed</span>
                </>
              )}
            </Link>
            <p>© {new Date().getFullYear()} {isSolo ? 'SEN-Education' : 'SEN-Ed'}. All rights reserved.</p>
            <div className="flex flex-wrap items-center justify-center sm:justify-end gap-4 sm:gap-6">
              {isSolo ? (
                <>
                  <Link to="/about" className={linkClass(isSolo)}>About</Link>
                  <Link to="/contact" className={linkClass(isSolo)}>Contact</Link>
                  <Link to="/privacy" className={linkClass(isSolo)}>Privacy</Link>
                  <Link to="/terms" className={linkClass(isSolo)}>Terms</Link>
                  <Link to="/security" className={linkClass(isSolo)}>Security</Link>
                  <Link to="/cookies" className={linkClass(isSolo)}>Cookies</Link>
                  <a href="https://sen-ed.co.uk" rel="noopener noreferrer" className={linkClass(isSolo)}>Go to our schools site</a>
                </>
              ) : (
                <>
                  <Link to="/privacy" className="hover:text-indigo-600">Privacy</Link>
                  <Link to="/terms" className="hover:text-indigo-600">Terms</Link>
                  <Link to="/security" className="hover:text-indigo-600">Security</Link>
                </>
              )}
            </div>
          </div>
          {isSolo && (
            <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">
              SEN-Education is a product of The Send Tech Company Ltd (SEN-Ed is a trading name). Company number 16756429. We never ask for your password by email or phone. Log in only via <strong>app.sen-education.co.uk</strong>.
            </p>
          )}
        </div>
      </footer>
    </div>
  );
}

function linkClass(isSolo) {
  return isSolo ? 'text-gray-500 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400' : 'text-gray-500 hover:text-indigo-600 dark:text-gray-400';
}
